import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from "react-intl";
import { connect, } from "react-redux";
import { get, post, checkHttpStatus } from '../../utils/RestUtilsWithAxios';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button  from "@material-ui/core/Button";
import Dropdown from '../../components/Dropdown';
import { alertBox } from '../../components/BoxProvider';
import * as Globals from '../../constants/globals';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import MaterialUIDatePicker from '../../components/EyatUIDatePicker'; 
import TransactionTradeInfo from './TransactionTradeInfo';
import TransactionTransferInfo from './TransactionTransferInfo';
import TransactionDWInfo from './TransactionDWInfo';

import {
    GET_INVESTOR_PLATFORM_LIST,
    GET_CRYPTO_TRANSACTIONS,

} from '../../constants/uri';


const headStyles = makeStyles(theme => ({
    headFont: {
        fontSize: 13,
        fontWeight: 600
    },
    fontBold: {
        fontWeight: 600
    }
}));

/**
 * EnhancedTableHead
 * @param props
 * @return {*}
 * @constructor
 */
function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };
    const headClasses = headStyles();

    const headRows = [
        { id: 'platformName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.PLATFORM_NAME" }) },
        { id: 'currencyCode', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_CODE" }) },
        { id: 'currencyName', numeric: false, disablePadding: false, label: props.intl.formatMessage({ id: "KVMKS.ACCOUNT.CURRENCY_NAME" }) }
    ];

    return (
        <TableHead>
            <TableRow>
                {headRows.map(row => (
                    <TableCell
                        key={row.id}
                        align={row.numeric ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === row.id ? order : false}
                        className={headClasses.headFont}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                        >
                            {
                                    <div>{row.label}</div>
                            }
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}
EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};


const useSearchStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        marginBottom: theme.spacing(2),
        margin: 'auto',
        padding: 30,
        paddingTop: 20
    },
    formControl: {
        margin: theme.spacing(1),
    },
    group: {
        margin: theme.spacing(1, 0),
    },
    showButton: {
        marginTop: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            width: 200
        },
    },
    infoMsg: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30
    },
    textContainer: {
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
    },

}))
const transactionTypeList = [
        {value:"TR", label:"Alım-Satım"}, 
        {value:"TF", label:"Aktarım"},  
        {value:"D", label:"Yatırma"}, 
        {value:"W", label:"Çekme"}
    ]

/**
 * Transactions
 * @param props
 * @return {*}
 * @constructor
 */
function Transactions(props) {
    const searchClasses = useSearchStyles();
    const [memberIdAndBusinessNameList, setMemberIdAndBusinessNameList] = useState([]);
    const [memberIdAndBusinessNameAndTitleList, setMemberIdAndBusinessNameAndTitleList] = useState([]);
    const [selectedMemberId, setSelectedMemberId] = useState(null);
    const [trades, setTrades] = useState([]);
    const [transfers, setTransfers] = useState([]);
    const [depositWithdrawals, setDepositWithdrawals] = useState([]);
    const [platformIdAndBusinessNameMap, setPlatformIdAndBusinessNameMap] = useState({});
    const [selectedTransactionType, setSelectedTransactionType] = useState(null);
    const [selectedBeginDate,setSelectedBeginDate] = useState(beginInit());
    const [selectedEndDate,setSelectedEndDate] = useState(endInit());
    const [memberName, setMemberName] = useState("");
    const [platformName, setPlatformName] = useState("");
    const [showDataNotFoundMessage, setShowDataNotFounddMessage] = useState(false)


    /**
     * formatMonthOrDay
     * @param m
     * @return {*}
     */
    function formatMonthOrDay(m) {
        if(m<10)
            return '0'+m;
        else
            return m;
    }

    /**
     * beginInit
     * @return {string}
     */
    function beginInit(){
        var date = new Date();
        date.setDate(date.getDate()-30);
        return date.getFullYear().toString()+(formatMonthOrDay(date.getMonth()+1)).toString()+
            (formatMonthOrDay(date.getDate())).toString();
    }

    /**
     * endInit
     * @return {string}
     */
    function endInit() {
        var date = new Date();
        return date.getFullYear().toString()+(formatMonthOrDay(date.getMonth()+1)).toString()+
            (formatMonthOrDay(date.getDate())).toString();
    }

    React.useEffect(() => {
        get(GET_INVESTOR_PLATFORM_LIST)
            .then(function (response) {
                setMemberIdAndBusinessNameAndTitleList(response.data)
                const formatted = response.data.map(item => ({
                                value: item.platformId,
                                label: item.platformBusinessName
                                }));
                setMemberIdAndBusinessNameList(formatted);
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
    }, []);

    /**
     * memberSelected
     * @param changedValue
     */
    function memberSelected(changedValue) {
        const foundObj = memberIdAndBusinessNameList.find(item => item.value === changedValue);
        setMemberName(foundObj?.label)
        setSelectedMemberId(changedValue);

    }

    /**
     * transactionTypeSelected
     * @param changedValue
     */
    function transactionTypeSelected(changedValue) {
        setSelectedTransactionType(changedValue);
    }

    /**
     * retreiveTransactionData
     */
    function retreiveTransactionData() {
        var endDate = new Date(selectedEndDate.substring(0,4)+'-'+selectedEndDate.
        substring(4,6)+'-'+selectedEndDate.substring(6,8));
        var compareToEnd = new Date(selectedBeginDate.substring(0,4)+'-'+selectedBeginDate.
        substring(4,6)+'-'+selectedBeginDate.substring(6,8));
        
        if (compareToEnd.getTime() > endDate.getTime()) {
            alertBox("", 'Başlangıç Tarihi Bitiş Tarihinden büyük olamaz.', Globals.ALERT_ERROR, props.intl);
            return;
        }
        compareToEnd.setDate(compareToEnd.getDate()+30);

        if(compareToEnd.getTime() < endDate.getTime()){
            alertBox("", 'Seçtiğiniz tarih aralığı 30 günden büyük olamaz', Globals.ALERT_ERROR, props.intl);
            return;
        }

        if(!selectedMemberId || selectedMemberId === '' ){
            alertBox("", 'Platform seçimi yapınız', Globals.ALERT_WARNING, props.intl);
            return;
        }

         if(!selectedTransactionType || selectedTransactionType === '' ){
            alertBox("", 'İşlem tipi seçimi yapınız', Globals.ALERT_WARNING, props.intl);
            return;
        }
        
        post(GET_CRYPTO_TRANSACTIONS, {platformId:selectedMemberId, startDate:selectedBeginDate , endDate:selectedEndDate , transactionType:selectedTransactionType})
            .then(function (response) {               
                if (response?.data) {
                    setTrades(response.data.tradeList)
                    setTransfers(response.data.transferList)
                    setDepositWithdrawals(response.data.depositWithdrawalList)
                    setPlatformIdAndBusinessNameMap(response.data.platformIdAndBusinessNameMap)
                    setShowDataNotFounddMessage(true)
                }
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
        setPlatformName(memberName);    
    }

    return (
        <div className={searchClasses.root}>
            <Paper className={searchClasses.paper} >
                <Typography variant="h5">Tarih Aralığı</Typography>
                <Grid container direction="row" spacing={3} style={{marginBottom:16}}>
                    <Grid item xs={12} sm={4}>
                        <MaterialUIDatePicker containerId="mui-pickers-date" label="Başlangıç Tarihi"
                                                setContainerSelectedDate={setSelectedBeginDate}
                                                dateString={selectedBeginDate}/>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <MaterialUIDatePicker containerId="mui-pickers-date2" label="Bitiş Tarihi"
                                                setContainerSelectedDate={setSelectedEndDate}
                                                dateString={selectedEndDate}/>
                    </Grid>
                </Grid>
                <Typography variant="h5">İşlem Bilgileri</Typography>
                <Grid container direction="row" spacing={3} style={{marginBottom:16}}>
                    <Grid item xs={12} sm={4}>
                        <Dropdown required={true} name="memberIdAndBusinessNameList" id="memberIdAndBusinessNameList" title={"Platform Adı"} items={memberIdAndBusinessNameList}
                                  handleContainerChange={memberSelected} containerSelectedItem={selectedMemberId} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Dropdown required={true} name="transactionType" id="transactionType" title={"İşlem Türü"} items={transactionTypeList}
                                  handleContainerChange={transactionTypeSelected}
                                  containerSelectedItem={selectedTransactionType} />
                    </Grid>
                </Grid>
                
                <Grid container justify="flex-end">
                    <Button variant='contained' color='primary' size='large' onClick={retreiveTransactionData}
                            className={searchClasses.showButton} fullWidth>
                        {props.intl.formatMessage({ id: "COMMON.BUTTON_SHOW" })}
                    </Button>
                </Grid>
            </Paper>
            {showDataNotFoundMessage && <Paper className={searchClasses.paper}>
              
                   {trades?.length > 0 && <TransactionTradeInfo tradeList= {trades} platformName = {platformName} intl={props.intl} />}
                   {transfers?.length > 0 && <TransactionTransferInfo transferList={transfers} platformName = {platformName} intl={props.intl}  />}
                   {depositWithdrawals?.length > 0 && <TransactionDWInfo dwList={depositWithdrawals} platformName = {platformName} intl={props.intl}/>}
                   {
                    (!Array.isArray(trades) || trades?.length === 0 ) && (!Array.isArray(transfers) || transfers?.length === 0 ) && (!Array.isArray(depositWithdrawals) || depositWithdrawals?.length === 0 )
                    && showDataNotFoundMessage &&
                    <Typography align='center' searchClasses={{h6: searchClasses.textContainer}} variant='h6'>
                        {"Seçilen tarih aralığında işlem hareketi bulunmamaktadır."}
                    </Typography>
                   } 
            </Paper>}
            <Paper className={searchClasses.infoMsg}>
                <Grid container style={{backgroundColor: "white"}}>
                    <Typography display="inline" variant="subtitle1">
                        {"(*) Bu sayfada yer alan bilgiler, ilgili platformlar tarafından MKK'ya iletilen verilerden oluşmaktadır. Hata, eksiklik ya da uyumsuzluk durumunda verilerin düzeltilmesi için ilgili kripto varlık platformuna başvurabilirsiniz."}
                    </Typography>
                </Grid>
            </Paper>
        </div>
    )
}

/**
 * injectIntl
 */
export default injectIntl(
    connect(
        null,
    )(Transactions)
);